<template>
    <div class="backgroundWrapper charm-bg">
        <div class="listToggle">
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item" @click="showTimesBox">
                <div class="nav-link" :class="{ 'active': activeTab === 'thisweek' }" @click="activateTab('thisweek')"
                    data-toggle="tab" href="#thisweek" role="tab">This Week</div>
                </li>
                <li class="nav-item" @click="hideTimesBox">
                <div class="nav-link" :class="{ 'active': activeTab === 'lastweek' }" @click="activateTab('lastweek')"
                    data-toggle="tab" href="#lastweek" role="tab">Last Week</div>
                </li>
            </ul>
            <div class="timesBox" v-show="isTimesBoxVisible">
                <CounterdownCompo :isVisible="true" :showDays="true" />
            </div>
        </div>
        <div class="tab-content">
            <div class="tab-pane" :class="{ 'active': activeTab === 'thisweek' }" id="thisweek" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoadedThisWeek">
                    <ThisWeekTabCont />
                    <!-- <CharmRewardBlastThisWeek /> -->
                </div>
            </div>
            <div class="tab-pane" :class="{ 'active': activeTab === 'lastweek' }" id="lastweek" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoadedLastWeek">
                    <LastWeekTabCont />
                    <!-- <CharmRewardBlastLastWeek /> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ThisWeekTabCont from './ThisWeekTabCont.vue'
import LastWeekTabCont from './LastWeekTabCont.vue'
import CounterdownCompo from '../CounterdownCompo.vue';
// import CharmRewardBlastLastWeek from './CharmRewardBlastLastWeek.vue';
// import CharmRewardBlastThisWeek from './CharmRewardBlastThisWeek.vue';
export default {
    name: 'CharmCompTab',
    components: {
        ThisWeekTabCont,
        LastWeekTabCont,
        // CharmRewardBlastThisWeek,
        // CharmRewardBlastLastWeek,
        CounterdownCompo
    },
    data() {
      return {
        isTimesBoxVisible: true,
        activeTab: 'thisweek',   
        isLoadedThisWeek: false,
        isLoadedLastWeek: false      
      };
    },    
    methods: {    
        showTimesBox() {
            this.isTimesBoxVisible = true;            
        },
        hideTimesBox() {
            this.isTimesBoxVisible = false;            
        },    
        activateTab(tabId) {
            this.activeTab = tabId;
            if(tabId === 'thisweek' && !this.isLoadedThisWeek) {
                this.isLoadedThisWeek = true
            }
            if(tabId == 'lastweek' &&!this.isLoadedLastWeek) {
                this.isLoadedLastWeek = true
            }
        },
    } ,
    mounted() {
        this.isLoadedThisWeek = true
    }, 
}
</script>